// extracted by mini-css-extract-plugin
export default {"title-button-row":"configuration-page_title-button-row__eBgfK","section-card":"configuration-page_section-card__SMy7S"};